'use client';

import { ensureSignupStepStyle } from './signup-step-style';

export interface StepsListProps {
  /** Accessible name of the list. */
  label: string;
  steps: readonly string[];
  /** Index of the step the member is on; it reads bold and as the current step. */
  currentIndex: number;
}

/** v7 Web/Steps list: the context screen's numbered "what to expect" list. */
export function StepsList({ label, steps, currentIndex }: StepsListProps) {
  ensureSignupStepStyle();
  return (
    <ol className="signup-steps-list" aria-label={label} data-testid="signup-context-steps">
      {steps.map((step, index) => (
        <li
          key={step}
          className="signup-steps-list__item"
          aria-current={index === currentIndex ? 'step' : undefined}
          data-testid={`signup-context-step-${index + 1}`}
        >
          {/* The list already numbers its items for assistive technology. */}
          <span className="signup-steps-list__disc" aria-hidden="true">
            {index + 1}
          </span>
          <span>{step}</span>
        </li>
      ))}
    </ol>
  );
}
